import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['price', 'totalsSubtotal', 'totalsDiscount', 'totalsTotal', 'discount', 'discountType', 'partialPaymentsNumber', 'quoteAmountContainer', 'partialCheckbox', 'paymentEntry', 'partialPaymentDiv']

  connect() {
    if (JSON.parse(this.data.get('approved'))) {
      return
    }
    this.set_quotes()
    this.verifyPartialPayment()
  }

  updateTotals() {
    let totalAmountWithoutDiscount = 0
    let grandTotal = 0

    this.priceTargets.forEach((priceTarget) => {
      if (priceTarget.value !== '' && this.isVisible(priceTarget)) {
        totalAmountWithoutDiscount += parseFloat(priceTarget.value.replace('.', '').replace(',', '.'))
      }
    })

    let discountAmount = 0
    const discountValue = parseFloat(this.discountTarget.value.replace('.', '').replace(',', '.'))
    if (this.discountTypeTarget.value == 'value') {
      discountAmount = discountValue
    } else {
      discountAmount = discountValue / 100 * totalAmountWithoutDiscount
    }

    let paymentEntry = parseFloat(this.paymentEntryTarget.value.replace('.', '').replace(',', '.'))
    paymentEntry = paymentEntry.toFixed(2).replace('.', ',');

    discountAmount = isNaN(discountAmount) ? 0 : discountAmount
    grandTotal = isNaN(totalAmountWithoutDiscount - discountAmount) ? '0,00' : (totalAmountWithoutDiscount - discountAmount).toFixed(2).replace('.', ',')
    discountAmount = discountAmount.toFixed(2).replace('.', ',');

    this.totalsSubtotalTarget.textContent = 'R$ ' + this.thousandDelimiter(totalAmountWithoutDiscount.toFixed(2).replace('.', ','))
    this.totalsDiscountTarget.textContent = 'R$ ' + this.thousandDelimiter(discountAmount)
    this.totalsTotalTarget.textContent = 'R$ ' + this.thousandDelimiter(grandTotal)
    this.paymentEntryTarget.textContent = 'R$ ' + this.thousandDelimiter(paymentEntry)

    this.set_quotes()
    this.verifyPartialPayment()
  }

  thousandDelimiter = (number) => {
    let parts = number.toString().split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')

    return parts.join(',');
  }

  isVisible(element) {
    return element.offsetHeight > 0
  }

  set_quotes() {
    var contentdiv = ""
    var numberOfQuotes = this.partialPaymentsNumberTarget.value
    var number = this.currencyToNumberQuotes(this.totalsTotalTarget.innerText) - (isNaN(parseFloat(this.paymentEntryTarget.value)) ? 0 : this.currencyToNumberQuotes(this.paymentEntryTarget.value))
    if (number < 0) {
      number = 0
    }
    number = this.numberToCurrencyQuotes((number/numberOfQuotes).toFixed(2))

    if(this.paymentEntryTarget.value === "") {
      this.paymentEntryTarget.textContent = "R$ 0,00"
    }

    contentdiv = `
      <div class="block-total">
        <div class="tw-flex tw-justify-between">
          <span class="title-total previus">Subtotal</span>
          <span data-target="quote-amount-totals.totalsSubtotal" class="value-total tw-font-bold quote-amount-container-span">${this.totalsSubtotalTarget.textContent}</span>
        </div>
        <div class="tw-flex tw-justify-between">
          <span class="title-total previus">Desconto</span>
          <span data-target="quote-amount-totals.totalsDiscount" class="value-total tw-font-bold quote-amount-container-span">${this.totalsDiscountTarget.textContent}</span>
        </div>
        <div class="tw-flex tw-justify-between">
          <span class="title-total">Total</span>
          <span data-target="quote-amount-totals.totalsTotal" class="value-total tw-text-green-600 tw-font-bold quote-amount-container-span">${this.totalsTotalTarget.textContent}</span>
        </div>
        ${this.partialCheckboxTarget.checked === true ?
          `<div class="tw-flex tw-justify-between">
            <span class="tw-mt-2 title-total previus quote-amount-currency-span">Entrada</span>
            <span data-target="quote-amount-totals.paymentEntry" class="value-total tw-mt-2 quote-amount-span">${this.paymentEntryTarget.value === "0,00" ||  this.paymentEntryTarget.textContent === "" ? `${this.numberToCurrencyQuotes(parseFloat(this.paymentEntryTarget.value))}` : this.paymentEntryTarget.textContent}</span>
          </div>` : ""
        }
        ${this.partialCheckboxTarget.checked === true ?
        `<div class="tw-flex tw-justify-between">
          <span class="title-total previus quote-amount-currency-span">Parcelas</span>
          ${!numberOfQuotes ? `<span class="value-total quote-amount-container-span quote-amount-currency-span">1 x R$ 0,00</span>` : `<span class="value-total quote-amount-container-span quote-amount-span">${numberOfQuotes} x ${number === "R$ NaN,00" || number === "R$ In.fin.ity,00" ? "R$ 0,00" : number}</span>`}
        </div>` : ""
        }
      </div>
    `
    this.quoteAmountContainerTarget.innerHTML = contentdiv
  }

  currencyToNumberQuotes = (value) => {
    if(value === "") {
      value =  0;
    } else {
      value = value.replace(".","");
      value = value.replace(",",".");
      value = value.replace("R$","");
      value = parseFloat(value);
    }

    return value;
  }

  numberToCurrencyQuotes = (value) => {
    var integer = null, decimal = null, c = null, j = null;
      var aux = new Array();
      value = "" + value;
      c = value.indexOf(".", 0);

      if(c > 0){
         integer = value.substring(0, c);
         decimal = value.substring(c+1, value.length);
      }else{
         integer = value;
      }

      for (j = integer.length, c = 0; j > 0; j -= 3, c++){
         aux[c] = integer.substring(j-3,j);
      }

      integer = "";

      for(c = aux.length-1; c >= 0; c--){
         integer += aux[c] + '.';
      }

      integer = integer.substring(0, integer.length-1);
      decimal = parseInt(decimal);

      if(isNaN(decimal)){
         decimal = "00";
      }else{
         decimal = "" + decimal;
         if(decimal.length === 1){
            decimal = decimal + "0";
         }
      }

      value = "R$ " + integer + "," + decimal;

      return value;
  }

  verifyPartialPayment() {
    if (this.totalsTotalTarget.textContent !== "R$ 0,00") {
      this.partialCheckboxTarget.removeAttribute("disabled")
    } else {
      this.partialCheckboxTarget.setAttribute("disabled", "disabled")
      this.partialCheckboxTarget.checked = false
      this.partialPaymentDivTarget.classList.add("hide")
      this.paymentEntryTarget.value = "0,00"
      this.partialPaymentsNumberTarget.value = 1
      this.set_quotes()
    }
  }

}

